/** Empties an input the way typing would, so React's onChange (and react-hook-form) see the change, then refocuses it. */
export function clearNativeInput(input: HTMLInputElement) {
  const setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
  setValue?.call(input, '');
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.focus();
}
